import { Box } from '@/components/atoms/Grid'
import styled, { keyframes, css } from 'styled-components'
import { FC } from 'react'

type TabPanelProps = {
  index: string
  value: string
  animation?: boolean
}

const TabPanel: FC<TabPanelProps> = ({
  index,
  value,
  animation = true,
  children
}) => {
  return index !== value ? null : (
    <StyledBox animation={animation}>{children}</StyledBox>
  )
}

export default TabPanel

const fadeIn = keyframes`
 0% { display: none; opacity: 0; }
 1% { display: inherit; opacity: 0; }
 100% { display: inherit; opacity: 1; }
`

const fadeInAnimation = css`
   {
    ${fadeIn} 0.5s ease-out
  }
`

const StyledBox = styled(Box)`
  animation: ${(props) => (props.animation ? fadeInAnimation : 'none')};
`
